// extracted by mini-css-extract-plugin
export default {"AddCommentEditor":"AddCommentEditor-module__AddCommentEditor--JFfip"};